import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

export const Videos = styled(Flex).attrs({
  padding: '0 0 0 10px',
  spacing: 15,
  wrap: 'wrap',
  justify: 'space-around',
})`
  width: 100%;
  height: 100%;
`;

export const EmptyVideos = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
  fillSpace: true,
})`
  color: grey;
`;
